import React from "react";

export default () => {
	React.useEffect(() => {
		//redirect from old url to new url
		window.location.href = "/metal-solutions/industries/industrial-automation";
	}, []);
	return <></>;
};
